namespace TabAurous.Production {
    export interface QualityInspectionValuesForm {
        TransItemId: Serenity.StringEditor;
        Parameter: Serenity.StringEditor;
        ExpectedValue: Serenity.StringEditor;
        InspectedValue: Serenity.StringEditor;
        Min: Serenity.StringEditor;
        Max: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class QualityInspectionValuesForm extends Serenity.PrefixedContext {
        static formKey = 'Production.QualityInspectionValues';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QualityInspectionValuesForm.init)  {
                QualityInspectionValuesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(QualityInspectionValuesForm, [
                    'TransItemId', w0,
                    'Parameter', w0,
                    'ExpectedValue', w0,
                    'InspectedValue', w0,
                    'Min', w0,
                    'Max', w0,
                    'Remark', w0
                ]);
            }
        }
    }
}
